var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.cropperSizeCss)},[_c('cropper',{ref:"cropper",staticClass:"cropper",class:[_vm.cropperPointerEventsClass, { outlined: _vm.localImageProperties !== undefined }],attrs:{"src":_vm.image,"debounce":false,"canvas":false,"check-orientation":false,"stencil-props":{
            aspectRatio: _vm.channelAspectRatio,
            movable: _vm.showBehavior,
            resizable: _vm.showBehavior,
        },"resizeImage":{
            wheel: false // Disable the wheel zoom
        }},on:{"change":_vm.change}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }